import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../../../../components/Web/OrderConfirmation/redesign/confirmationHeading';
import { isWHWP2 } from '../../../../components/common/Helpers';
// import { getAPPID } from '../../../../components/common/Helpers';

const mapStateToProps = (state) => {
  const cartSelector = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const contactInfoSelector = cartSelector && cartSelector.primaryUserInfo ? cartSelector.primaryUserInfo : {};
  const isAALContactInfoUpdated = state.contactInfo && state.contactInfo.isAALContactInfoUpdated ? state.contactInfo.isAALContactInfoUpdated : false;
  const isredemptionDowngrade = isWHWP2() && state?.addons?.isDowngradeRedemption;
  // const isLoggedIn = getAPPID() === 'AAL';
  return {
    contactInfoValues: contactInfoSelector || {},
    isAALContactInfoUpdated,
    isredemptionDowngrade,
  };
};

function mapDispatchToProps() {}
const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default withRouter(compose(withConnect)(Header));
